import React from "react";
import PropTypes from "prop-types";

import Checkbox from "core/Checkbox";

import { CardLinksFlexbox, FormButtonBodyText } from "./styles";

const CardLinks = ({
    className,
    showSavedCard,
    hasSavedCard,
    handleUseCardClick,
    saveCardCheckboxOnClick,
    saveCardInitialValue
}) => {
    return (
        <CardLinksFlexbox justifyContent="space-between" className={className}>
            {showSavedCard ? (
                <FormButtonBodyText
                    type="button"
                    size="md"
                    bottomSpacing="lg"
                    onClick={handleUseCardClick}
                >
                    Use a different card
                </FormButtonBodyText>
            ) : (
                <>
                    {hasSavedCard && (
                        <FormButtonBodyText
                            type="button"
                            size="md"
                            onClick={handleUseCardClick}
                        >
                            Use saved card
                        </FormButtonBodyText>
                    )}
                    <Checkbox
                        label={`${hasSavedCard ? "Replace" : "Save"} this card`}
                        onClick={saveCardCheckboxOnClick}
                        isChecked={saveCardInitialValue}
                    />
                </>
            )}
        </CardLinksFlexbox>
    );
};

CardLinks.propTypes = {
    showSavedCard: PropTypes.bool.isRequired,
    hasSavedCard: PropTypes.bool.isRequired,
    handleUseCardClick: PropTypes.func.isRequired,
    saveCardCheckboxOnClick: PropTypes.func.isRequired,
    saveCardInitialValue: PropTypes.bool.isRequired
};

export default CardLinks;
